import React from 'react';
import Loadable from 'react-loadable';
import { useSelector } from 'react-redux';

import {
  PrimaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';

import { RootState } from 'reducers/index';
import featureFlags from 'util/featureFlags';
import NavMapper from 'components/navV2/NavMapper/NavMapper';
import { getUserContext } from 'selectors/user';
import { isDesktop, isLargeDesktop } from '@zola-helpers/client/dist/es/util/responsive';
import RegistryVisibilityToggle from './RegistryVisibilityToggle/RegistryVisibilityToggle';

import { QuickLinksWrapper } from './QuickLinks.styles';

const RegistryShareButton = Loadable({
  loader: () => import('./RegistryShareButton/RegistryShareButton'),
  loading: () => <React.Fragment />,
});

export type QuickLinksProps = {
  quickLinksData: SecondaryNavItem[];
  hideContentOnScroll: boolean;
  activeLinkId?: '' | PrimaryNavIdentifier;
};

const QuickLinks = (props: QuickLinksProps): JSX.Element => {
  const { hideContentOnScroll, quickLinksData, activeLinkId } = props;
  const userContext = useSelector((state: RootState) => getUserContext(state));

  const combineIntoOneDropdown = () => {
    const children = quickLinksData.flatMap((quickLink) => {
      return quickLink.children || quickLink;
    });

    return [
      {
        identifier: 'see-more-registry-dropdown',
        title: 'More',
        showCaret: true,
        children,
        dockRight: true,
      },
    ];
  };
  const quickLinks =
    typeof window !== 'undefined' && isDesktop() && !isLargeDesktop()
      ? combineIntoOneDropdown()
      : quickLinksData;

  const showRegistryOptions =
    activeLinkId === PrimaryNavIdentifier.REGISTRY && userContext.has_registry;

  return (
    <QuickLinksWrapper hideContentOnScroll={hideContentOnScroll}>
      {showRegistryOptions && <RegistryVisibilityToggle />}
      {showRegistryOptions && featureFlags.get('registryShareOptions') && <RegistryShareButton />}
      <NavMapper
        navData={quickLinks}
        type="Secondary"
        className="navSecondary__container--postAuthNavV3"
      />
    </QuickLinksWrapper>
  );
};

export default QuickLinks;
